// 限时拉新
export default () =>
  import(
    /* webpackChunkName: 'coffee/app/invite-period-limit' */ './InvitePeriodLimit'
  );
